import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import type { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'
import { rewardsDetailsBreadcrumbAtom } from '../atoms/breadcrumbAtom'

export const useRewardsDetailsBreadcrumbs = (): CustomBreadCrumbConfig[] => {
  const currency = useAtomValue(rewardsDetailsBreadcrumbAtom)

  return useMemo(
    () => [
      {
        title: 'rewards.title',
        link: PathNames.REWARDS,
      },
      ...(currency ? [{ title: currency }] : []),
    ],
    [currency]
  )
}
